module.exports = __webpack_public_path__ + "img/zwei_symetrische_lasten.4d783607.jpg";